import { mapActions } from 'vuex';

export default {
  computed: {
    notifications() {
      return this.$store.state._core.toastNotifications.notifications;
    }
  },
  watch: {
    'notifications': {
      handler(newValue, oldValue) {
        const oldIds = oldValue?.map(item => item.id);
        const addedNotifications = newValue?.filter(item => !oldIds?.includes(item.id));

        if (addedNotifications?.length) {
          this.$nextTick(() => {
            const notifications = newValue;

            let index = 0;

            const logItems = setInterval(() => {
              if (index < notifications.length) {
                const notification = notifications[index];

                this.$toastNotification({
                  props: notification
                }, {});

                index++;
              } else {
                clearInterval(logItems);
              }
            }, 500);
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      actionReadNotification: '_core/toastNotifications/actionReadNotification'
    }),
    onToastClose(e) {
      this.actionReadNotification({
        notificationId : e.id,
        recipientId    : e.recipientId
      });
    },
    onToastClick(e) {
      this.$router.push(e.recipientTargetUrl);
    }
  }
};
